'use strict';

var _ = require('lodash');

function DialogService ($rootScope) {
  
  var ctrls = {};
  var opened = {}; // currently open dialogs

  this.closed = function (ctrlId) {
    var ctrl = ctrls[ctrlId];
    var groupId = ctrl.group;

    // remove the closed dropdown from the opened list
    if (opened[groupId]) {
      delete opened[groupId][ctrlId];
    }
  };

  this.opened = function (ctrlId) {
    var ctrl = ctrls[ctrlId];
    var groupId = ctrl.group;

    // close open dialogs in same group
    closeGroup(groupId, ctrlId);

    // keep track of the open dropdowns
    opened[groupId] = opened[groupId] || {};
    opened[groupId][ctrlId] = ctrl;
  };

  /**
   * Registers a dialog
   * 
   * @param  {string} [groupId] group that this dialog should be grouped with
   * @param  {object} ctrl Angular ctrl for the dialog
   */
  this.register = function (groupId, ctrl) {
    ctrl.group = groupId;
    ctrls[ctrl.$id] = ctrl;
  };

  this.unregister = function (groupId, ctrlId) {
    delete ctrls[ctrlId];

    if (opened[groupId]) {
      delete opened[groupId][ctrlId];
    }
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////
  // Helpers
  /////////////////////////////////////////////////////////////////////////////////////////////////
  
  function closeAll () {
    _.forEach(opened, function (group, groupId) {
      closeGroup(groupId);
    });
  }

  var closeGroup = function (groupId, ctrlId) {
    var group = opened[groupId];

    if (group) {
      _.forEach(group, function (ctrl) {
        if (ctrl.$id !== ctrlId) {
          ctrl.close();
        }
      });
    }
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////
  // Event Handlers
  /////////////////////////////////////////////////////////////////////////////////////////////////
  
  var onCloseAll = function () {
    closeAll();
  };

  var onLocationChange = function () {
    closeAll();
  };

  $rootScope.$on('dialog:closeAll', onCloseAll);
  $rootScope.$on('$locationChangeSuccess', onLocationChange);

  
  /////////////////////////////////////////////////////////////////////////////////////////////////
  // Testing Only
  // 
  // The following have been exposed for testing only and not intended to be used
  /////////////////////////////////////////////////////////////////////////////////////////////////

  this._ctrls = ctrls;
  this._opened = opened;
  this._closeAll = closeAll;
  this._closeGroup = closeGroup;
}

DialogService.$inject = ['$rootScope'];
module.exports = DialogService;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/dialog/src/DialogService.js